import { render, staticRenderFns } from "./PartnerUnauthorized.vue?vue&type=template&id=2ada7b8c"
import script from "./PartnerUnauthorized.vue?vue&type=script&lang=ts"
export * from "./PartnerUnauthorized.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports